import photo1 from '../Components/img/chocolate-cake.jpg';
import photo2 from '../Components/img/Assorted Candy Mix.jpg';
import photo3 from '../Components/img/Vanilla Cupcakes (6-pack).jpg';
import photo4 from '../Components/img/Glazed Donuts (12-pack).jpg';

export const products = [
  {
    id: 1,
    name: "Chocolate Fudge Cake",
    price: 24.99,
    description: "Rich chocolate cake with fudge icing and chocolate shavings",
    image: photo1 ,
    category: "cakes",
    rating: 4.8,
  },
  {
    id: 2,
    name: "Assorted Candy Mix",
    price: 12.99,
    description: "1 pound of our finest assorted candies and chocolates",
    image: photo2,
    category: "candies",
    rating: 4.5,
  },
  {
    id: 3,
    name: "Vanilla Cupcakes (6-pack)",
    price: 14.99,
    description: "Fluffy vanilla cupcakes with buttercream frosting",
    image: photo3,
    category: "cupcakes",
    rating: 4.7,
  },
  {
    id: 4,
    name: "Glazed Donuts (12-pack)",
    price: 18.99,
    description: "Freshly made donuts with classic sugar glaze",
    image: photo4,
    category: "donuts",
    rating: 4.9,
  },
];

